export default function ErrorPage() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Sorry, This page doesn't exist, please go back.</p>

      <button onClick={() => window.history.back()} className="button-2">Go Back</button>
    </div>
  )
}